module.exports = __webpack_public_path__ + "assets/images/rbyearend-14-desktop.jpg?v=6699bf7b";